const $ = selector => document.querySelectorAll(selector);

export const shorten = (str, maxLen, separator = ' ') => {
  if (str.length <= maxLen) return str;
  return `${str.substr(0, str.lastIndexOf(separator, maxLen))}…`;
};

const findParent = (element, parent) => {
  let nodeList = element.parentNode;
  let a = 0;
  while (nodeList) {
    if (nodeList === document) {
      break;
    }
    if (nodeList.classList && nodeList.classList.contains(parent)) {
      return nodeList;
    }
    a += a;
    nodeList = nodeList.parentNode;
  }
  return document;
};

const findTarget = ({ element, parent, target }) => findParent(element, parent).querySelector(`.${target}`);

const endPoint = {
  interest: '/wp-json/app/v1/interest',
  newsletter: '/wp-json/app/v1/newsletter',
  search: '/wp-json/app/v1/search',
  contact: '/wp-json/app/v1/contact',
  reseller: '/wp-json/app/v1/reseller',
  course: '/wp-json/app/v1/courses',
  order: '/wp-json/app/v1/order',
  category: '/wp-json/app/v1/categories/course/',
  cart: '/wp-json/app/v1/cart',
  job: '/wp-json/app/v1/job',
};

const loading = {
  config: {
    classname: '-loading',
  },
  show(target) {
    // remove old results from target ?
    target.innerHTML = '';
    // show loading
    target.classList.add(loading.config.classname);
  },
  stop(target) {
    target.classList.remove(loading.config.classname);
  },
};

const dataExist = (obj, key) => (obj[key] !== undefined && (key in obj) && obj[key] !== '');

const freeze = (() => {
  const freezeCN = 'freeze';
  const html = document.querySelector('html');

  const start = () => {
    html.classList.add(freezeCN);
  };
  const stop = () => {
    html.classList.remove(freezeCN);
  };

  return {
    start,
    stop,
  };
})();

export { $, findParent, findTarget, endPoint, dataExist, loading, freeze };



// WEBPACK FOOTER //
// ./utils/Utils.js